import styled from 'styled-components';
import breakpoint from '../../../../../utils/style-utils';

export const ColumnWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1 1 100%;
`;

export const ColumnLayoutContainer = styled.div`
	--column-gap: 20px;

	display: flex;
	gap: var(--column-gap);
	padding: 0 12px;

	${breakpoint.lg`
		padding: 0;
	`}

	min-width: 0; // Fix for overflow hidden on flex children

	// If the container has two column wrappers as sibling children we want to make sure one column can't be bigger than the other.
	// This can happen in the event view when there is a widget in the right column. We don't control the CSS inside the widget.
	&:has(${ColumnWrapper} + ${ColumnWrapper}) ${ColumnWrapper} {
		max-width: calc(50% - var(--column-gap) / 2);
	}
`;
